import reducer from './reducer';

export const { closeModal, setOnline } = reducer.actions;
